import type { GridColumnMenuItemProps } from "@mui/x-data-grid-premium";
import {
  getRowGroupingFieldFromGroupingCriteria,
  GridPinnedColumnPosition,
  useGridApiContext,
} from "@mui/x-data-grid-premium";
import React from "react";
import FreezeMenuItem from "./FreezeMenuItem.tsx";
import UnfreezeMenuItem from "./UnfreezeMenuItem.tsx";

const ColumnMenuFreezeItem = ({ colDef, onClick }: GridColumnMenuItemProps) => {
  const gridApi = useGridApiContext();
  const groups = gridApi.current.state.rowGrouping;

  const groupedColumns = groups.model.map((group) => getRowGroupingFieldFromGroupingCriteria(group));
  const isGroupedColumn = groupedColumns.some((group) => group === colDef.field);
  const unfreezeLabel = isGroupedColumn ? "Unfreeze Grouped Columns" : "Unfreeze Column";
  const freezeLabel = isGroupedColumn ? "Freeze Grouped Columns" : "Freeze Column";

  if (!colDef) {
    return null;
  }

  const freezeColumn = (event: React.MouseEvent<HTMLElement>) => {
    gridApi.current.pinColumn(colDef.field, GridPinnedColumnPosition.LEFT);
    onClick(event);
  };

  const unfreezeColumn = (event: React.MouseEvent<HTMLElement>) => {
    gridApi.current.unpinColumn(colDef.field);
    onClick(event);
  };

  const side = gridApi.current.isColumnPinned(colDef.field);

  if (side) {
    return <UnfreezeMenuItem label={unfreezeLabel} unfreezeColumn={unfreezeColumn} />;
  }
  return <FreezeMenuItem label={freezeLabel} freezeColumn={freezeColumn} />;
};

export default ColumnMenuFreezeItem;
